import { ACL_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  PutApiClientSpacesRequestParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onSuccess?: (value: string[]) => void
  onError?: (error: Error) => void
  children?: (value: string[]) => ReactElement
  apiAccessId: string
  params: PutApiClientSpacesRequestParams
}

const PutApiClientSpacesRequest = ({
  apiAccessId,
  params,
  onSuccess,
  onError,
  children
}: Props) => {
  const url = `${ACL_SERVICE}/principals/${apiAccessId}/access`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default PutApiClientSpacesRequest
